<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.settings'),
                        href: null,
                    },
                    {
                        name: $t('messages.open_ai'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    <div>
                        {{ $t('messages.information') }}
                    </div>

                    <div>
                        <IconBrandOpenai class="w-10 h-10 text-gray-400" />
                    </div>
                </template>
                <div v-if="settings.masked_key">
                    <span class="font-mono text-gray-400">{{ settings.masked_key }}</span>
                </div>
                <div class="mt-1">
                    <FormLabel :value="$t('messages.api_key')" for="key" />
                    <FormInput
                        required
                        id="key"
                        v-model.trim="form.key"
                        name="key"
                        type="text"
                        max="100"
                        autocomplete="false"
                        class="mt-1 w-full"
                    />
                    <FormError :value="form.errors.key" class="mt-2" />
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton
                    :button-text="$t('messages.save')"
                    :processing="form.processing"
                    :disabled="!form.key"
                />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import FormError from '@/components/Forms/FormError.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import { IconBrandOpenai } from '@tabler/icons-vue';

export default {
    components: {
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        SubmitFormButton,
        PanelPage,
        FormError,
        IconBrandOpenai,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'settings'],
    data() {
        return {
            form: this.$inertia.form({
                key: '',
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update, {
                onSuccess: () => {
                    this.form.reset();
                },
            });
        },
    },
};
</script>
